module.exports = __webpack_public_path__ + "static/segoe-6b90e08dbc52c415321fda150ea74210.svg";